<form [formGroup]="representForm" class="ids-pt-8">
  <section formArrayName="represents">
    <section *ngFor="let represent of representArray.controls; let i = index">
      <section [formGroupName]="i" style="display: flex; flex-direction: column">
        <section class="ids-row" style="display: flex; justify-content: space-between">
          <div class="ids-col-6 represent__exclused">
            <h3 class="ids-col-6 ids-text-section-02">representante {{ i + 1 }}</h3>
          </div>
          <div class="ids-col-6">
            <button
              *ngIf="i >= 1"
              idsActionButton
              idsOverlayOrigin
              class="ids-col-6"
              (click)="setIsOpenModalRemoveRepresent(i)"
              style="min-height: auto"
            >
              <ids-icon>excluir_outline</ids-icon>
              excluir
            </button>
          </div>
        </section>

        <section class="ids-row">
          <ids-form-field class="ids-col-6" label="nome completo" [errorMessage]="getTextFieldError(i, 'name', 'o nome completo')">
            <input idsInput formControlName="name"/>
          </ids-form-field>

          <ids-form-field class="ids-col-6" label="CPF" [errorMessage]="getErrorInvalid('CPF')">
            <input idsMask="000.000.000-00" idsInput formControlName="documentNumber"/>
          </ids-form-field>
        </section>
      </section>
    </section>
  </section>

  <button
    idsActionButton
    type="button"
    (click)="addRepresent()"
    *ngIf="this.representArray.length < 4"
    class="ids-pt-8 ids-pb-8"
  >
    <ids-icon>add_circle_base</ids-icon>
    incluir mais um representante
  </button>
</form>

<ids-modal
  [(open)]="isOpenModalRemoveRepresent"
  width="800px"
>
  <ids-modal-header noDivider></ids-modal-header>
  <p class="ids-section-title -small ids-mx-4">deseja excluir este representante?</p>
  <div
    class="ids-card ids-m-4 ids-p-4"
    *ngIf="currentItemSelected?.name || currentItemSelected?.documentNumber"
  >
    <section class="ids-row">
      <section class="ids-col-6">
        <h3 class="ids-text-label-small ids-pt-3">nome completo</h3>
        <p class="ids-text-section-01 ids-pb-4">
          {{ currentItemSelected?.name || '-' }}
        </p>
      </section>
      <section class="ids-col-6">
        <h3 class="ids-text-label-small ids-pt-3">CPF</h3>
        <p class="ids-text-section-01 ids-pb-4">
          {{ currentItemSelected?.documentNumber || '-' }}
        </p>
      </section>
    </section>
  </div>

  <ids-modal-footer>
    <button idsMainButton variant="secondary" (click)="closeModal()">não excluir</button>
    <button idsMainButton (click)="modalConfirmRemove()">sim, quero excluir</button>
  </ids-modal-footer>
</ids-modal>
